// extracted by mini-css-extract-plugin
export default {"statusPanelAlert":"pZvP2lAbtIJoA9ddnaIGG","warningText":"_1xamCow_lMW40RLSXERBFj","warningIcon":"_1FQ6zbniC0H2z7iM70rDWr"};